import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Alert,
} from '@mui/material';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the original location (with search params like ?qr=xxx)
  const from = location.state?.from;
  const fromPath = from?.pathname || '/admin';
  const fromSearch = from?.search || '';

  if (user) {
    navigate(fromPath + fromSearch, { replace: true });
    return null;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate(fromPath + fromSearch, { replace: true });
    } catch (err) {
      setError('Login failed. Check your email and password.');
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh', p: 2 }}>
      <Card sx={{ width: '100%', maxWidth: 420, p: 3, boxShadow: 6, borderRadius: 3 }}>
        <CardContent>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Admin Login
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Sign in with your Firebase email and password to access admin features.
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <TextField
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              required
              sx={{ mb: 3 }}
            />
            <Button type="submit" variant="contained" fullWidth disabled={loading}>
              {loading ? 'Signing in…' : 'Sign In'}
            </Button>
          </Box>

          <Typography variant="caption" display="block" sx={{ mt: 3 }}>
            If you just created users in Firebase, use those credentials here.
          </Typography>

          <Button component={Link} to="/" variant="text" sx={{ mt: 2 }}>
            Back to Home
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoginPage;
